import React, { useEffect, useState } from "react";
import img from "./1000049778.jpg";

function About() {
  const [date, setDate] = useState("");
  const [time, setTime] = useState("");
  const [loading, setLoading] = useState(true); // Loading state to manage the indicator

  useEffect(() => {
    const interval = setInterval(() => {
      const now = new Date();
      setDate(now.toLocaleDateString());
      setTime(
        now.toLocaleTimeString([], {
          hour: "2-digit",
          minute: "2-digit",
          second: "2-digit",
        })
      );
      setLoading(false); // Once the time and date are loaded, set loading to false
    }, 1000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="bg-img text-light ">
        <div className="africa ">
          <div className="flexi closed">
            {" "}
            <div>
              <h1 id="welcome">
                <div className="name2"> Prasoon</div>
                <div className="name">Kandel</div>
              </h1>
            </div>
            <div className="img">
              <img src={img} alt="loading...." id="img" />
            </div>
          </div>
        </div>
      </div>
      <div className="flex-my dtm" style={{ justifyContent: "space-around" }}>
        {loading ? (
          <div>Loading...</div> // Display loading indicator
        ) : (
          <>
            <div className="time-animate">Time: {time}</div>
            <div className="time-animate">Date: {date}</div>
          </>
        )}
      </div>
    </>
  );
}

export default About;
